import Axios from 'axios';
import { store } from '../../node_modules/@bmp-vue/core/plugins/store';
import { FormatURLParams } from '../utils/axiosUtils';
import util from '@bmp-vue/core/api/util';
import ui from '@bmp-vue/core/api/ui';
const crypto = require('crypto');
const gerarIdempotencyKey = () => crypto.randomBytes(16).toString('hex');

const axios = {
  GetParams: function (controller, params) {
    const { token } = JSON.parse(localStorage.getItem('user'));
    params = params ? FormatURLParams(params) : {};
    return Axios.get(controller, {
      params,
      headers: { authorization: `Bearer ${token}` }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  DownloadExcelFile: function (controller, params, fileName) {
    const { token } = JSON.parse(localStorage.getItem('user'));
    params = params ? FormatURLParams(params) : {};
    return Axios.get(controller, {
      params,
      headers: { authorization: `Bearer ${token}` },
      responseType: 'blob'
    }).then(res => {
      const disposition = res.headers['content-disposition'];
      if (disposition && disposition.indexOf('filename=') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
          disposition
        );
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, '');
        }
      }

      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName || 'arquivo.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();

      ui.HideLoading();
    }, HandleErrorBase);
  },

  DownloadTxtFile: function (controller, params, fileName) {
    const { token } = JSON.parse(localStorage.getItem('user'));
    params = params ? FormatURLParams(params) : {};

    return Axios.get(controller, {
      params,
      headers: { authorization: `Bearer ${token}` },
      responseType: 'blob'
    }).then(res => {
      const disposition = res.headers['content-disposition'];
      if (disposition && disposition.indexOf('filename=') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
          disposition
        );
        if (matches && matches[1]) {
          fileName = matches[1].replace(/['"]/g, '');
        }
      }

      const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName || 'arquivo.txt');
      document.body.appendChild(link);
      link.click();
      link.remove();

      ui.HideLoading();
    }, HandleErrorBase);
  },

  DownloadJsonFile: function (controller, params, fileName) {
    const { token } = JSON.parse(localStorage.getItem('user'));
    params = params ? FormatURLParams(params) : {};
    return Axios.get(controller, {
      params,
      headers: { authorization: `Bearer ${token}` },
      responseType: 'blob'
    }).then(res => {
      const disposition = res.headers['content-disposition'];
      if (disposition && disposition.indexOf('filename=') !== -1) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
          disposition
        );
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, '');
        }
      }

      const blob = new Blob([res.data], {
        type: 'application/json'
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      ui.HideLoading();
    }, HandleErrorBase);
  },

  DownloadZipFile: function (controller, params, fileName) {
    const { token } = JSON.parse(localStorage.getItem('user'));
    params = params ? FormatURLParams(params) : {};

    return Axios.get(controller, {
      params,
      headers: { authorization: `Bearer ${token}` },
      responseType: 'blob'
    }).then(res => {
      const disposition = res.headers['content-disposition'];
      if (disposition && disposition.includes('filename=')) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
          disposition
        );
        if (matches?.[1]) fileName = matches[1].replace(/['"]/g, '');
      }
      const blob = new Blob([res.data], { type: 'application/zip' });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download =
        fileName && fileName.endsWith('.zip')
          ? fileName
          : fileName || 'arquivo.zip';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

      ui.HideLoading();
    }, HandleErrorBase);
  },

  Post: function (controller, dto, headers, token) {
    const idempotencyKey = gerarIdempotencyKey();
    token = token ?? JSON.parse(localStorage.getItem('user')).token;
    store.commit('addRequest');
    if (headers) {
      headers.idempotencyKey = idempotencyKey;

      return Axios.post(controller, dto, headers).then(
        HandleResponseBase,
        HandleErrorBase
      );
    } else {
      return Axios.post(controller, dto, {
        headers: {
          authorization: `Bearer ${token}`,
          idempotencyKey
        }
      }).then(HandleResponseBase, HandleErrorBase);
    }
  },

  PostForm: function (controller, dto) {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));
    return Axios.post(controller, dto, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${dto._boundary}`,
        authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  Put: function (controller, id, dto) {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));
    if (!dto) {
      dto = {};
    }
    return Axios.put(controller + '/' + id, dto, {
      headers: {
        authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  PutCommand: function (controller, dto) {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));

    if (!dto) dto = {};

    return Axios.put(controller, dto, {
      headers: {
        authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  Delete: (controller, id) => {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));
    return Axios.delete(controller + '/' + id, {
      headers: {
        authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  DeleteDTO: (controller, id, dto) => {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));

    const queryString = new URLSearchParams(dto).toString();

    return Axios.delete(controller + '/' + id + '?' + queryString, {
      headers: {
        authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  DeleteCommand: (controller, dto) => {
    const idempotencyKey = gerarIdempotencyKey();
    const { token } = JSON.parse(localStorage.getItem('user'));

    const queryString = new URLSearchParams(dto).toString();

    return Axios.delete(controller + '?' + queryString, {
      headers: {
        authorization: `Bearer ${token}`,
        idempotencyKey
      }
    }).then(HandleResponseBase, HandleErrorBase);
  },

  Get: (controller, id) => {
    const { token } = JSON.parse(localStorage.getItem('user'));
    return Axios.get(controller + '/' + id, {
      headers: {
        authorization: `Bearer ${token}`
      }
    }).then(HandleResponseBase, HandleErrorBase);
  }
};

const api = {
  ...util,
  Axios: axios,
  controller: 'UTIL', //passar UTIL apenas se quiser sobreescrever a UTIL padrão
  HandleResponseBase,
  HandleErrorBase
};

function HandleResponseBase(response) {
  ui.HideLoading();
  store.commit('removeRequest');

  if (
    (response.count && response.data) ||
    (response.count === 0 && response.data == [])
  ) {
    return response;
  }
  if (response.data.meta) {
    return response.data;
  }
  if (response.data.data || response.data.data == []) {
    if (response.data.count || response.data.count === 0) {
      return response.data;
    }
    return response.data.data;
  }

  return response.data;
}

function HandleErrorBase(error) {
  ui.HideLoading();
  store.commit('removeRequest');

  if (error) {
    const response = error.response;
    if (response) {
      if (response.data.messages) {
        response.data.messages.map(message =>
          ui.ShowError(
            message.context,
            `${message.code} - ${message.description}`
          )
        );
        return response;
      }
    }
  }

  ui.ShowError('Erro', 'Ocorreu um erro inesperado');
  return { data: { hasError: true } };
}

export default api;
